module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-right-panel-1-aceed7a38c8d9c31593bfc04575b6abb.svg";